// extracted by mini-css-extract-plugin
export default {"root":"CourseTypeFilter_root__vXUkp"};